import {Typography} from '@yandex-delivery/ui'
import {SafeHTML} from '@yandex-delivery/xss-defender'
import React from 'react'

import {type RequirementType} from '../../../../../../../../api'
import styleClasses from './classes.module.css'

type Props = {
  requirement: RequirementType
}

export function Requirement({requirement}: Props) {
  const {name, value} = requirement

  return (
    <div className={styleClasses.requirement}>
      <Typography density="tight" level="caption1" weight="regular">
        <div>
          <SafeHTML html={name} />
        </div>
      </Typography>
      <div className={styleClasses.dots} />
      <Typography density="tight" level="caption1" weight="regular">
        <div>
          <SafeHTML html={value} />
        </div>
      </Typography>
    </div>
  )
}
